import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=28862029&scoped=true&"
import script from "./printer.vue?vue&type=script&lang=js&"
export * from "./printer.vue?vue&type=script&lang=js&"
import style0 from "./printer.vue?vue&type=style&index=0&id=28862029&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28862029",
  null
  
)

export default component.exports